export default __webpack_public_path__ + "static/media/companyon-button.88ab4b4f.svg";